//@ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'

import _ from 'lodash'
import {
  Button,
  DatePickerInput,
  Divider,
  Dropdown,
  Form,
  Grid,
  Modal,
  Text,
  TextArea,
} from '@wework/dieter-ui'
import MemberOverview from './MemberOverview'
import AutoCompleteTextField from './AutoCompleteTextField'

import addDays from 'date-fns/addDays'
import HeldSpaces from './HeldSpaces'
import { withSnackbar } from '../../../hoc/SnackBarProvider'
import withSession from 'hoc/withSession'
import algoliasearch from 'algoliasearch/lite'
// const HOLD_KEYWORDS_REGEX = /\b(sav(e|ing)|hold|sell|interest|reserv|paperwork|ppw)/i

function SpaceHoldModal({
  open,
  handler,
  spaces,
  floorMap,
  session,
  snackBars,
}: any) {
  const [holdNote, setHoldNote] = useState('')
  const [endDate, setEndDate] = useState(undefined)
  // const [value, setValue] = useState(spaces[0]?.reservable?.note)
  const [selected, setSelected] = useState({})
  const [companies, setCompanies] = useState([])
  const [company, setCompany] = useState({})
  const [editingMode, setEditingMode] = useState<boolean>(false)
  const [suggestions, setSuggestions] = useState([])
  const contactField = useRef(null)
  const [submitting, setSubmitting] = useState(false)
  let algoliaClient: any = {}
  let algoliaIndex = undefined

  useEffect(() => {
    if (spaces.length > 0 && spaces[0].reservable?.officeHold) {
      setEditingMode(true)
      const hold = spaces[0].reservable?.officeHold
      const existingHold = {
        contact_info_name: hold.contactInfoName,
        contact_info_email: hold.contactInfoEmail,
        companies: [{ name: hold.companyName, uuid: hold.companyUUID }],
        contact_info_phone: hold.contactInfoPhone,
        holdUUID: hold.uuid,
      }
      setCompany({ name: hold.companyName, uuid: hold.companyUUID })
      setEndDate(new Date(hold.endsAt))
      setSelected(existingHold)
    }
    return () => {
      setEditingMode(false)
      setSelected({})
      setCompany({})
      setEndDate(undefined)
    }
  }, [spaces])

  const searchBuilder = (query, indices) => {
    const search: any = []
    indices.map((indice: any) => {
      if (indice) search.push({ indexName: indice, query })
    })
    return search
  }

  const indice = _.get(session, 'tokens.algolia.indices.all', '')
  const appId = _.get(session, 'tokens.algolia.app_id', '')
  const key = _.get(session, 'tokens.algolia.key', '')
  try {
    algoliaClient = algoliasearch(appId, key)
    algoliaIndex = algoliaClient.initIndex(indice)
  } catch (e) {
    console.error(e)
  }
  const unifyResults = (usersSuggestions, contactInfos) => {
    if (contactInfos) {
      const mappedInfos = contactInfos.hits.map(contactInfo => ({
        ...contactInfo,
        name: contactInfo.contact_name.replace('[not provided]', ''),
        uuid: contactInfo.contact_uuid,
        companies: contactInfo.company_name && [
          { name: contactInfo.company_name },
        ],
      }))
      return [...usersSuggestions.hits, ...mappedInfos]
    }
    return usersSuggestions.hits
  }

  const createHoldForSpace = async (space, info, company, note, endDate) => {
    const { reservable } = space
    if (!reservable) {
      throw new Error("Space doesn't have reservable")
    }

    const occupancyExtension = floorMap.getExtension('reservable')
    if (!occupancyExtension) {
      console.error('No an occupancy extension found')
      throw new Error('No an occupancy extension found')
    }

    const contactInfo = {
      ...info,
      email: info.contact_info_email,
      phone: info.contact_info_phone,
      company_uuid: company?.uuid,
      company_name: company?.name,
      contact_uuid: info.account_id,
      contact_name: info.contact_info_name,
    }

    const r = await occupancyExtension.createOfficeHold(
      reservable.uuid,
      note,
      contactInfo,
      endDate
    )
    return r
  }

  const validateInfo = info => {
    // eslint-disable-next-line camelcase
    const { contact_info_email, contact_info_name } = info

    // eslint-disable-next-line camelcase
    if (!contact_info_email || !contact_info_name) {
      return false
    }

    return true
  }

  const handleOnRemoveHold = async () => {
    const reservable = _.get(spaces, '[0].reservable')
    if (!reservable) {
      return
    }

    const onHold = reservable.officeHold
    if (!onHold) {
      console.error('No an on hold found')
      return
    }

    const occupancyExtension = floorMap.getExtension('reservable')
    if (!occupancyExtension) {
      console.error('No an occupancy extension found')
      return
    }
    setSubmitting(true)
    try {
      await occupancyExtension.removeOfficeHold(onHold.uuid, reservable.uuid)
      snackBars.addAlert({
        text: `Successfully removed on hold.`,
        variant: 'success',
      })

      handler(false)
    } catch (e) {
      console.error(e)
      snackBars.addAlert({
        text: `The space was unsuccessful removing on hold. Please try again.`,
        variant: 'error',
      })
    }

    setSubmitting(false)
  }

  const updateOnHold = async (note, endDate) => {
    const reservable = _.get(spaces, '[0].reservable')

    const occupancyExtension = floorMap.getExtension('reservable')
    if (!occupancyExtension) {
      console.error('No an occupancy extension found')
      throw new Error('No an occupancy extension found')
    }
    setSubmitting(true)

    try {
      const response = await occupancyExtension.updateOfficeHold(
        selected.holdUUID,
        reservable.uuid,
        note,
        endDate
      )
      snackBars.addAlert({
        text: 'Hold note was successfully updated.',
        variant: 'success',
      })
    } catch (e) {
      snackBars.addAlert({
        text:
          'Hold update unsuccessful, please check selected spaces and try again.',
        variant: 'error',
      })

      console.error(e)
    }
    setSubmitting(false)
    handler(false)
  }

  const handleOnSubmitHold = async (info, company, note, endDate) => {
    const valid = validateInfo(info)
    if (!valid) {
      snackBars.addAlert({
        text: `We cannot proceed with the hold request since ${info.contact_info_email} has incomplete information.`,
        variant: 'error',
      })

      return null
    }
    setSubmitting(true)

    if (editingMode) {
      return updateOnHold(note, endDate)
    }

    const result = {
      errorCount: 0,
      success: [],
    }
    try {
      // eslint-disable-next-line no-restricted-syntax
      for (const space of spaces) {
        try {
          // eslint-disable-next-line no-await-in-loop

          const r = await createHoldForSpace(
            space,
            info,
            company,
            note,
            endDate
          )
          result.success.push(r)
        } catch (e) {
          result.errorCount += 1
        }
      }

      let notifyMessage = 'The space was successfully put on hold.'

      if (result.errorCount === spaces.length) {
        throw new Error('All put on hold request are failed')
      }

      if (spaces.length > 1) {
        if (result.errorCount === 0) {
          notifyMessage = `All ${_.size(
            result.success
          )} spaces were successfully put on hold.`
        } else {
          notifyMessage = `Successfully put ${result.success} out of ${spaces.length} selected spaces on hold.`
        }
      }
      snackBars.addAlert({
        text: notifyMessage,
        variant: 'success',
      })
    } catch (e) {
      snackBars.addAlert({
        text: `Put on hold unsuccessful, please check selected spaces and try again.`,
        variant: 'error',
      })

      console.error(e)
    }

    setSubmitting(false)

    handler(false)
    return null
  }

  const dataSourceHandler = async (query, cb = e => {}) => {
    const usersIndice = _.get(session, 'tokens.algolia.indices.users', '')
    const contactInfosIndice = _.get(
      session,
      'tokens.algolia.indices.contactInfo'
    )
    const indices = []
    if (usersIndice) {
      indices.push(usersIndice)
    }
    if (contactInfosIndice) {
      indices.push(contactInfosIndice)
    }
    if (indices.length === 0) {
      console.error('No indices specified')
      return
    }
    if (!algoliaIndex) {
      console.error('Unable to initialize algolia client')
      return
    }
    try {
      const content = await algoliaClient.search(searchBuilder(query, indices))
      const usersIndiceContent = content.results.find(
        result => result.index === usersIndice
      )
      const contactInfosContent = content.results.find(
        result => result.index === contactInfosIndice
      )
      const usersSuggestions = unifyResults(
        usersIndiceContent,
        contactInfosContent
      )
      cb(usersSuggestions)
      const distinctHits = _.uniqBy(usersSuggestions, 'name')
      const suggestions = distinctHits.map((suggestion: any) => ({
        contact_info_name: suggestion.name,
        contact_info_email: suggestion.email,
        account_id: suggestion.uuid,
        companies: suggestion.companies,
        contact_info_phone: suggestion.normalized_phone,
      }))
      setSuggestions(suggestions)
    } catch (e) {
      console.error(e)
    }
  }

  const handleOnSaveHold = () => {
    handleOnSubmitHold(selected, company, holdNote, endDate)
  }

  const handleAutoTextFieldChange = email => {
    const suggestion = suggestions.find(s => s.contact_info_email === email)

    if (suggestion) {
      setSelected(suggestion)
      setCompany(_.get(suggestion, 'companies[0]'))
      setCompanies(
        suggestion.companies.map((company, index) => {
          return {
            key: 1,
            text: company.name,
            value: company.uuid,
            name: company.name,
            uuid: company.uuid,
          }
        })
      )
    } else {
      setSelected({})
    }
  }

  const minDate = addDays(new Date(), 2)
  const maxDate = addDays(new Date(), 7)

  return (
    <Modal
      onClose={() => handler(false)}
      onOpen={() => handler(true)}
      open={open}
    >
      <Modal.Header>Hold space</Modal.Header>
      <Modal.Content>
        <Text style={{ fontSize: 14, marginBottom: 8 }}>
          <b>
            {session?.user_data.first_name} {session?.user_data.last_name}
          </b>{' '}
          is holding {spaces.length} spaces.
        </Text>
        {spaces && <HeldSpaces spaces={spaces || []} />}
        <Divider light style={{ width: '100%', marginBottom: 24 }} />
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <Text size="medium" style={{ fontWeight: '700' }}>
                Holding for
              </Text>
              <Text size="tiny">
                Select a Member or a Potential member for which you hold the
                office.
              </Text>
            </Grid.Column>
            <Grid.Column
              width={8}
              style={{ border: '1px solid #E6E6E6', padding: 16 }}
            >
              <MemberOverview selected={selected} selectedCompany={company} />
            </Grid.Column>
          </Grid.Row>
          <Divider light style={{ width: '100%', marginBottom: 24 }} />
          <Grid.Row>
            <Grid.Column width={8}>
              <Form>
                <AutoCompleteTextField
                  disabled={editingMode}
                  autoComplete="off"
                  testID="on-hold-modal"
                  suggestions={suggestions}
                  ref={contactField}
                  type="contact_info_email"
                  label="Email"
                  placeholder="Search for email or name"
                  id="email"
                  //@ts-ignore
                  value={selected?.contact_info_email}
                  onChange={handleAutoTextFieldChange}
                  dataSource={value => {
                    dataSourceHandler(value)
                  }}
                  required
                />
                {companies.length > 0 && (
                  <Form.Field
                    label="Company"
                    control={Dropdown}
                    outline
                    //@ts-ignore
                    onChange={(e, data) => {
                      setCompany(
                        companies.find(company => company.value === data.value)
                      )
                    }}
                    defaultValue={companies[0].value}
                    inputProps={{
                      style: { width: '100' },
                    }}
                    style={{ width: '100%' }}
                    // value={'hehhe'}
                    options={companies}
                    selection={true}
                    // value="02-123"
                  />
                )}
                <Form.Field
                  from={minDate}
                  outline
                  value={endDate}
                  label={'End date'}
                  className="dateInputWrapper"
                  // placeHolder="End date"
                  inputProps={{
                    style: { width: '100%' },
                    placeholder: undefined,
                    className: 'upDatePicker',
                    keepFocus: true,
                  }}
                  overla
                  keepFocus={true}
                  onDayChange={date => {
                    setEndDate(date)
                  }}
                  dayPickerProps={{
                    disabledDays: { before: minDate, after: maxDate },
                  }}
                  style={{ width: '100%' }}
                  to={maxDate}
                  control={DatePickerInput}
                />
              </Form>
            </Grid.Column>
            <Grid.Column width={8} style={{}}>
              <Form>
                <Form.Field
                  control={TextArea}
                  className={'fullWidth'}
                  value={holdNote}
                  label="Reason (optional)"
                  outline
                  // error={!isValidLength}
                  id="hold-note"
                  rows={5}
                  //@ts-ignore
                  onChange={e => setHoldNote(e.target.value)}
                />
                <Text
                  size="small"
                  style={{
                    textAlign: 'right',
                    fontSize: 12,
                    color: '#666666',
                    marginTop: 4,
                  }}
                >
                  {holdNote.length} / 255 Characters
                </Text>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        {editingMode && (
          <Button
            onClick={() => handleOnRemoveHold(false)}
            negative
            disabled={submitting}
            loading={submitting}
          >
            Remove Hold
          </Button>
        )}
        <Button
          onClick={() => handler(false)}
          default
          disabled={submitting}
          loading={submitting}
        >
          Cancel
        </Button>
        <Button
          primary
          disabled={submitting}
          loading={submitting}
          onClick={() => handleOnSaveHold()}
          // then(() => handler(false))
        >
          Put on hold
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default withSession()(withSnackbar(SpaceHoldModal))
